import { useState } from "react";
import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import CapabilityStrip from "@/components/site/CapabilityStrip";
import IntelligenceAndPlatform from "@/components/site/IntelligenceAndPlatform";
import WhyAndCTA from "@/components/site/WhyAndCTA";
import Footer from "@/components/site/Footer";
import DemoDialog from "@/components/site/DemoDialog";

export default function HomePage() {
  const [demoOpen, setDemoOpen] = useState(false);
  const openDemo = () => setDemoOpen(true);

  return (
    <div className="min-h-screen bg-obsidian text-platinum" data-testid="esthera-app">
      <Navbar onBookDemo={openDemo} />
      <main>
        <Hero onBookDemo={openDemo} />
        <CapabilityStrip />
        <IntelligenceAndPlatform onBookDemo={openDemo} />
        <WhyAndCTA onBookDemo={openDemo} />
      </main>
      <Footer />
      <DemoDialog open={demoOpen} onClose={() => setDemoOpen(false)} />
    </div>
  );
}
